<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="border-card"
      :before-leave="onBeforeLeave"
    >
      <el-tab-pane
        :label="$l('shipment_customer_setting_info') || '基本设置'"
        name="base"
      >
        <edit-form
          ref="editForm"
          :disabled="isDisableEditForm"
          :shipmentCustomerSettingCode="params.code"
        />

        <div class="d-flex justify-content-end mb-2 mt-2">
          <el-button
            v-if="!isDisableEditForm"
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('shipment_customer_setting_declaration_info') || '金额设置'"
        name="goods"
        lazy
      >
        <SettingDeclaration
          :shipmentCustomerSettingCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_pane_title_operators') || '运营人员'"
        name="opt"
        lazy
      >
        <div class="userrange-container">
          <UserRange
            :shipmentCustomerSettingCode="params.code"
            :disabled="isDisableEditForm"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('shipment_customer_setting_hscode_info') || '清关HSCODE配置'"
        name="hscode"
        lazy
      >
        <SettingHscode
          :shipmentCustomerSettingCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('tips_shipment_customer_setting_alter') || '订舱交期预警配置'
        "
        name="alert"
        lazy
      >
        <SettingAlert
          :shipmentCustomerSettingCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SettingDeclaration from '../components/setting-declaration'
import UserRange from '../components/userrange'
import SettingHscode from '../components/setting-hscode'
import SettingAlert from '../components/setting-alert'
export default {
  name: 'transport-customerSetting-detail',
  components: {
    EditForm,
    SettingDeclaration,
    UserRange,
    SettingHscode,
    SettingAlert,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    onBeforeLeave(val) {
      if (val === 'base') {
        return true
      }
      if (!this.params.code || this.pageType === 'add') {
        this.$message.warning(
          this.$l('INDEX.tips_save_basicinfo_first') || '请先保存基本信息!'
        )
        return false
      }
    },
  },
}
</script>
<style lang="scss">
.userrange-container {
  height: 500px;
  .el-transfer-panel__body {
    min-height: 420px !important;

    .el-transfer-panel__list {
      height: 100% !important;
    }
  }
}
</style>
